import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'nso',
    fullName: 'Northern Sotho',
    nativeName: 'Sesotho sa Leboa',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid ya go swana",
    landing_title: "Selo se sengwe se se Makatšago se a Tla",
    landing_subtitle: "ArgVoid ke setudio sa ntshetsopele ya tiriso ye le dipapadi. Dula o lebeletše, dilo tše mpsha di tla tla kgauswinyane!",
    select_language: "Kgetha Polelo",
    search_placeholder: "Batla maleme...",
    terms_title: "Melawana ya Tirelo",
    policy_title: "Pholisi ya Sephiri",
    cookies_title: "Pholisi ya Dikhukhi",
    terms_content: `
        <strong>1. Kamogelo ya Dipeelano</strong><br>
        Ka go fihlelela ArgVoid, Melawana ye ya Tirelo e a amogelwa. Ge dipeelano tše di sa dumelelane, tirelo ga se ya swanela go šomišwa.<br><br>

        <strong>2. Tšhomišo ya Sefala</strong><br>
        ArgVoid le dikgopelo tša yona di fiwa "bjalo ka ge di le bjalo" bakeng sa merero ya tshedimošo le ya boitlhamelo. Tirelo e swanetše go šomišwa fela ka mabaka a molao.<br><br>

        <strong>3. Boitshwaro bjo bo Thibetšwego</strong><br>
        Go šomiša mafelo ao a hlaselegago gabonolo, go romela di-spam, goba go leka phihlelelo yeo e sa dumelelwago go mananeokgoparara go thibetšwe ka go tia.<br><br>

        <strong>4. Tlhaloso ya boikarabelo</strong><br>
        Sefala le ditirelo di ka fetošwa nako efe goba efe ntle le tsebišo. Ga go na tiisetšo yeo e filwego mabapi le nako ya go šoma goba go hwetšagala ga tirelo.
    `,
    policy_content: `
        <strong>1. Kgoboketšo ya Tshedimošo</strong><br>
        Sefala ga se nyake netefatšo ya mosediriši goba tlholo ya akhaonto mo nakong ye. Ga go tshedimošo ya go hlaola motho (go swana le maina goba diaterese tša imeile) yeo e kgoboketšwago ka mafolofolo go tšwa go baeti.<br><br>

        <strong>2. Datha ya Tšhomišo</strong><br>
        Ditshekatsheko tša motheo, tšeo di sa tsebjego di ka kgoboketšwa go kwešiša sephethephethe sa sebaka le go kaonafatša dikgopelo. Datha ye ga e kgokagantšwe le boitšhupo bja mosediriši ka botee.<br><br>

        <strong>3. Ditirelo tša Mokga wa Boraro</strong><br>
        Baabi ba mokgatlo wa boraro ba ka šomišwa bakeng sa ditirelo tša go amogela le tša go sekaseka. Mekgwa ya sephiri ya baabi ba ka go latelana e laola datha yeo e sa tsebjego yeo e šomišitšwego mananeokgoparara a bona.<br><br>

        <strong>4. Tšhireletšo ya Datha</strong><br>
        Megato e kwagalago ya tšhireletšo e a phethagatšwa go šireletša sefala. Le ge go le bjalo, ga go na mokgwa wa phetišetšo ka Inthanete wo o šireletšegilego ka mo go feletšego.<br><br>
    `,
    cookies_content: `
        <strong>1. Dikhukhi le Polokelo ya Selegae ke eng?</strong><br>
        Dikhukhi le polokelo ya selegae ya sephephediši ke difaele tše nnyane tša datha tšeo di bolokilwego go sedirišwa go gopola dikgetho tša peakanyo go ralala le diketelo.<br><br>

        <strong>2. Morero wa Tšhomišo</strong><br>
        Browser LocalStorage e šomišwa ka go tia go boloka dipeakanyo tša peakanyo, go swana le:<br>
        - Dikgetho tša polelo<br>
        - Peakanyo ya segokanyimmediamentsi sa sebolokigolo sa mosediriši (mohlala, peakanyo goba dipeakanyo tša sehlogo)<br>
        - Cache ya tirišo ya nakwana<br><br>

        <strong>3. Ga go na go Latela</strong><br>
        Dikhukhi le polokelo ya lefelong leo ga di šomišwe bakeng sa merero ya papatšo goba ya go latela ya motho wa boraro. ya data tsohle bolokwa ke ka tieo bakeng sa tshebetso ya motheo ya platform.<br><br>

        <strong>4. Taolo</strong><br>
        Datha ya sephephediši e ka hlakolwa nako efe goba efe ka dipeakanyo tša sephephediši, tšeo di tlago seta gape dipeakanyo dife goba dife tša selegae.
    `,
    cookie_consent_text: "Re šomiša dikhukhi tša motheo go netefatša gore weposaete e šoma gabotse, go swana le go boloka sešene ya gago e šoma, go boloka kgetho ya gago ya polelo, le dipeakanyo tše dingwe tša tlwaelo.",
    read_policy: "Bala Pholisi ya Dikhukhi",
    support_title: "Ikgokaganye le Thekgo",
    support_subject_label: "Hlogotaba",
    support_message_label: "Molaetša",
    support_submit_button: "Romela Molaetša",
    support_hint: "Ela hloko: Se se tla bula tirišo ya gago ya imeile ya go se fetoge go romela molaetša.",
    support_success_msg: "Go bula tirišo ya gago ya imeile...",
    support_error_msg: "E paletšwe ke go romela molaetša. Hle leka gape ka morago.",
    explorer_title: "Mohlohlomiši",
    history_title: "Histori",
    animation_title: "Ditshwantšho tša dipopaye",
    config_title: "Peakanyo ya",
    tool_mouse: "Kgetha (Ctrl + M) .",
    tool_brush: "Borashe (Ctrl + B) .",
    tool_brush_mode: "Mokgwa wa go Fetoša (E tiilego/E hlakilego) .",
    tool_eraser: "Sephumula (Ctrl + E) .",
    tool_brush_size: "Beakanya Bogolo bja Borashe",
    tool_bucket: "Tlatsa (Ctrl + F) .",
    tool_eyedropper: "Lerothodi la leihlo",
    tool_grid: "Gridi (Ctrl + Phetogo + B) .",
    tool_rotate: "Dikološa (Ctrl + Phetogo + R) .",
    tool_flip_h: "Flip H (Ctrl + Phetoho + H) .",
    tool_flip_v: "Flip V (Ctrl + Phetoho + V) .",
    tool_transpose: "Fetoša (Ctrl + Phetogo + T) .",
    label_width: "Bophara",
    label_height: "Bogodimo",
    label_frames: "Palo ya Diforeime",
    label_animation: "Setaele sa Dipopaye",
    label_background_color: "Mmala wa Lemorago",
    label_interval: "Sebaka sa nako",
    tool_anim_config: "Peakanyo ya Dipopaye",
    label_new_width: "Bophara bjo Bofsa",
    label_new_height: "Bophagamo bjo Bofsa",
    label_apply: "Diriša",
    label_colors: "Mebala ya",
    label_size: "Bogolo",
    label_tolerance: "Kgotlelelo",
    val_horizontal: "Rapamego",
    val_vertical: "Tsepamego",
    val_sequence: "Tatelano",
    val_bounce: "Fofa",
    val_random: "Sa kgetholle",
    val_solid: "Tšhipi",
    val_clear: "Tloša",
    action_add_sheet: "Letlakala le Lefsa",
    action_import: "Thomelo ka nageng",
    action_export: "Romela ntle",
    action_sort_projects: "Hlopha",
    sort_date_old: "Kgale ka ho fetisisa Pele",
    sort_date_new: "Newest Pele",
    sort_name_az: "Lebitso (A-Z) .",
    sort_name_za: "Lebitso (Z-A) .",
    action_new_sprite: "Sprite e Ncha",
    action_new_project: "Protšeke ye Mpsha",
    modal_save_all_title: "Boloka Diphetogo ka Moka",
    modal_save_all_desc: "Kgetha dithoto tšeo o tlago go di boloka:",
    modal_save_selected: "Boloka E Kgethilwe",
    action_saved: "E bolokilwe",
    modal_create_sprite_title: "Hlama Sprite ye Mpsha",
    modal_create_project_title: "Hlama Protšeke ye Mpsha",
    modal_add_sheet_title: "Oketša Letlakala le Lefsa",
    modal_rename_sheet_title: "Leina lefsa la Letlakala",
    modal_rename_sprite_title: "Rena leina la Sprite",
    modal_delete_sprite_title: "Phimola Sprite",
    modal_delete_project_title: "Phimola Projeke",
    modal_delete_sheet_title: "Phimola Letlakala",
    placeholder_sprite_name: "Leina",
    placeholder_project_name: "Leina",
    placeholder_sheet_name: "Leina",
    placeholder_new_name: "Leina le Lefsa",
    action_create: "Hlama",
    action_add: "Hlakanya",
    action_rename: "Rena leina lefsa",
    action_duplicate: "Pheta-pheta",
    action_delete: "Phumola",
    action_cancel: "Khansela",
    confirm_delete_sprite: "Na o na le bonnete bja gore o nyaka go phumola sprite ye?",
    confirm_delete_project: "Na o na le bonnete bja gore o nyaka go phumola projeke ye? Di-sprite ka moka di tla tlošwa.",
    confirm_delete_sheet: "Na o na le bonnete bja gore o nyaka go phumola letlakala le?",
    err_select_sprite: "Hle kgetha sprite pele.",
    err_select_project: "Hle kgetha projeke pele.",
    err_name_empty: "Leina le ka se be le lefeela.",
    err_sprite_exists: "Sprite yeo e nago le leina leo e šetše e le gona.",
    err_project_exists: "Protšeke yeo e nago le leina leo e šetše e le gona.",
    err_no_content: "Ga go na diteng tšeo o swanetšego go di boloka.",
    err_no_changes: "Ga go na diphetogo tšeo o swanetšego go di boloka.",
    err_delete_last_sheet: "E ka se phumole letlakala la mafelelo.",
    err_extract_frames: "Ga se a kgona go ntšha diforeime le ge e le dife.",
    err_indexeddb: "E paletšwe ke go boloka ka mo nageng. Sephephediši sa gago se ka no se thekge IndexedDB.",
    msg_upload_success: "Go tsenya go Atlegile: {0}",
    msg_upload_failed: "Go Laetša go Paletšwe: {0}",
    msg_save_success: "Boloka atlegile.",
    msg_saving: "Go boloka...",
    msg_multi_save_result: "Matlotlo a bolokilwego {0}. {1} go palelwa.",
    menu_title: "Menu ya dijo",
    menu_save: "Boloka",
    menu_save_all: "Boloka Bohle",
    menu_support: "Ikgokaganye le Thekgo",
    label_local_storage: "Polokelo ya Selegae",
    label_sign_in: "Saena ka gare",
    modal_export_title: "Thomelontle Sprite",
    label_filename: "Leina la faele",
    label_format: "Sebopego",
    action_export_confirm: "Romela ntle",
};

export default translations;
